// removed by extract-text-webpack-plugin
module.exports = {"contentPic":"_7Rh06xZqNnmlZrUYu4mct","img":"_1_cV4-pzNoZnu9bR2cy_an","content":"_3jxMw_kmv8xXFdOKAWC-VR","detailBlock":"_1SovHgRXiMSmbCH-Lb81ua","title":"_1s3IH4htMQQMoOalT3QvFU","chtDetailBlock":"_3DDCf4jZglTfT1AGUAmMmM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-pic/ContentPic.css
// module id = 381
// module chunks = 0